import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ObjectListName from 'automation-ui-references/customer-data/ObjectListName';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AlterListMembershipActionExplainer({
  action,
  flowObjectTypeId
}) {
  const {
    shouldAdd,
    listId
  } = action.metadata;
  const messageKey = shouldAdd ? 'automation-ui-action-features.action-features.alter-list-membership.explainer.add_cob' : 'automation-ui-action-features.action-features.alter-list-membership.explainer.remove_cob';
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: messageKey,
    objectTypeId: flowObjectTypeId,
    options: {
      listName: /*#__PURE__*/_jsx(ObjectListName, {
        id: listId
      })
    }
  });
}